<div class="db">
  <!-- Needs a reply: only when there is something waiting -->
  @if (pendingRequests() > 0) {
    <a routerLink="/agendas/requests" class="db-alert">
      <span class="db-alert__dot" aria-hidden="true"></span>
      <span class="flex-1">
        {{ pendingRequests() === 1 ? 'Tienes 1 solicitud de cita' : 'Tienes ' + pendingRequests() + ' solicitudes de cita' }}
        por responder.
      </span>
      <span class="db-alert__cta">Revisar</span>
    </a>
  }

  @if (error() && !loading()) {
    <div class="db-error" role="alert">
      <p>{{ error() }}</p>
      <button type="button" (click)="loadAll()">Intentar de nuevo</button>
    </div>
  }

  <!-- ============================================================ -->
  <!-- TODAY + THIS WEEK                                             -->
  <!-- ============================================================ -->
  <div class="db-row db-row--today">
    <section class="db-card db-today" aria-labelledby="db-today-title">
      <div class="db-today__head">
        <div>
          <h2 id="db-today-title" class="db-today__date">{{ todayLabel }}</h2>
          <p class="db-muted">
            @if (metrics(); as m) {
              @if (m.today.totalAppointments === 0) {
                Sin citas para hoy.
              } @else {
                {{ m.today.totalAppointments }} cita{{ m.today.totalAppointments !== 1 ? 's' : '' }}:
                {{ m.today.completedAppointments }} completada{{ m.today.completedAppointments !== 1 ? 's' : '' }},
                {{ m.today.pendingAppointments }} por atender@if (m.today.cancelledAppointments) {<span>, {{ m.today.cancelledAppointments }} cancelada{{ m.today.cancelledAppointments !== 1 ? 's' : '' }}</span>}
              }
            } @else {
              Cargando tu día…
            }
          </p>
        </div>
        <div class="db-actions">
          @if (canAccessSales()) {
            <a routerLink="/sales" class="db-btn db-btn--ghost">Nueva venta</a>
          }
          <a routerLink="/agendas" class="db-btn db-btn--primary">
            <svg class="size-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
            </svg>
            Agendar cita
          </a>
        </div>
      </div>

      @if (loading() && !metrics()) {
        <div class="db-agenda" role="status" aria-label="Cargando citas">
          @for (i of [1, 2, 3]; track i) {
            <div class="db-slot animate-pulse">
              <span class="h-4 w-14 rounded bg-gray-100 dark:bg-gray-800"></span>
              <span class="h-4 w-48 rounded bg-gray-100 dark:bg-gray-800"></span>
            </div>
          }
        </div>
      } @else if (todayEvents().length) {
        @let today = todayWindow();
        @if (today.before) {
          <button type="button" class="db-more db-more--top" (click)="showAllToday.set(true)">
            Ver {{ today.before === 1 ? 'la cita anterior' : 'las ' + today.before + ' citas anteriores' }}
          </button>
        }
        <ol class="db-agenda" [class.db-agenda--cut]="today.before">
          @for (e of today.events; track e.eventId) {
            <li class="db-slot" [attr.data-tone]="statusTone(e.statusCode)">
              <time class="db-slot__time" [attr.datetime]="e.startDate">{{ formatTime(e.startDate) }}</time>
              <span class="db-slot__rail" aria-hidden="true"></span>
              <div class="min-w-0 flex-1">
                <p class="db-slot__client truncate">{{ e.clientName }}</p>
                <p class="db-slot__service truncate">{{ e.serviceName }}@if (e.professionalName) {<span>{{ e.serviceName ? ' con ' : 'Con ' }}{{ e.professionalName }}</span>}</p>
              </div>
              <div class="db-slot__meta">
                <span class="db-slot__status">{{ e.statusName }}</span>
                @if (e.finalPrice) {
                  <span class="db-slot__price">
                    {{ formatCurrency(e.finalPrice) }}@if (e.paymentCompleted) {<span class="db-paid">, pagado</span>}
                  </span>
                }
              </div>
            </li>
          }
        </ol>
        @if (today.after) {
          <button type="button" class="db-more" (click)="showAllToday.set(true)">
            Ver {{ today.after === 1 ? '1 cita más' : today.after + ' citas más' }} de hoy
          </button>
        } @else if (showAllToday() && todayEvents().length > todayPreview) {
          <button type="button" class="db-more" (click)="showAllToday.set(false)">Ver menos</button>
        }
      } @else if (metrics()) {
        <p class="db-empty">
          Tienes el día libre. Comparte tu enlace de reservas o agenda una cita para llenarlo.
        </p>
      }

      @if (laterEvents().length) {
        <div class="db-later">
          <p class="db-label">Próximas citas</p>
          <ul>
            @for (e of laterEvents(); track e.eventId) {
              <li>
                <span class="db-later__when">{{ formatDay(e.startDate) }}, {{ formatTime(e.startDate) }}</span>
                <span class="truncate">{{ e.clientName }}, {{ e.serviceName }}</span>
              </li>
            }
          </ul>
          <a routerLink="/agendas" class="db-link">Ver calendario</a>
        </div>
      }
    </section>

    <section class="db-card db-week" aria-labelledby="db-week-title">
      <h2 id="db-week-title" class="db-card__title">Esta semana</h2>
      @if (metrics(); as m) {
        <dl class="db-week__list">
          <div>
            <dt>Citas</dt>
            <dd>
              <span class="db-figure">{{ m.week.totalAppointments }}</span>
              <span class="db-muted">{{ m.week.completedAppointments }} completadas, {{ m.week.pendingAppointments }} por atender</span>
            </dd>
          </div>
          <div>
            <dt>Ocupación de tus agendas</dt>
            <dd>
              @if (m.week.occupancyPercentage !== null) {
                <span class="db-figure">{{ m.week.occupancyPercentage | number:'1.0-0' }} %</span>
                <span class="db-meter" aria-hidden="true">
                  <span [style.width.%]="m.week.occupancyPercentage"></span>
                </span>
              } @else {
                <span class="db-muted">Configura tus horarios para calcularla.</span>
              }
            </dd>
          </div>
          @if (canAccessSales()) {
            <div>
              <dt>Ventas</dt>
              <dd>
                <span class="db-figure">{{ formatCurrency(m.sales.weekTotal) }}</span>
                <span class="db-muted">{{ m.sales.weekCount }} venta{{ m.sales.weekCount !== 1 ? 's' : '' }}; hoy {{ formatCurrency(m.sales.todayTotal) }}</span>
              </dd>
            </div>
          }
        </dl>
      } @else {
        <div class="space-y-4 animate-pulse" aria-hidden="true">
          @for (i of [1, 2, 3]; track i) {
            <div class="h-10 rounded bg-gray-100 dark:bg-gray-800"></div>
          }
        </div>
      }
    </section>
  </div>

  <!-- ============================================================ -->
  <!-- LAST 30 DAYS                                                  -->
  <!-- ============================================================ -->
  @if (analytics() !== undefined) {
    @let a = analytics();
    <div class="db-section-head">
      <h2 class="db-section-title">Últimos {{ periodDays }} días</h2>
      <p class="db-muted">Comparado con los {{ periodDays }} días anteriores</p>
    </div>

    <div class="db-row db-row--period">
      <!-- Revenue -->
      <section class="db-card db-revenue" aria-labelledby="db-revenue-title">
        <div class="flex flex-wrap items-baseline justify-between gap-2">
          <h3 id="db-revenue-title" class="db-label">Ingresos por citas</h3>
          @if (a && formatTrend(a.comparison.revenueTrend); as t) {
            <span class="db-trend" [attr.data-tone]="trendTone(a.comparison.revenueTrend)">{{ t }}</span>
          }
        </div>
        @if (a) {
          <p class="db-hero">{{ formatCurrency(a.kpis.totalRevenue) }}</p>
          @if (a.kpis.totalRevenue > 0) {
            <div class="db-bars" role="img" [attr.aria-label]="'Ingresos diarios de los últimos ' + periodDays + ' días'">
              @for (b of revenueBars(); track b.date) {
                <span class="db-bars__bar" [class.db-bars__bar--empty]="b.value === 0" [style.height.%]="b.height" [title]="b.label"></span>
              }
            </div>
            @if (revenueBars().length) {
              <div class="db-bars__axis" aria-hidden="true">
                <span>{{ formatShortDay(revenueBars()[0].date) }}</span>
                <span>Hoy</span>
              </div>
            }
          } @else {
            <p class="db-empty">Aún no hay citas cobradas en este período.</p>
          }
        } @else {
          <div class="mt-3 h-36 animate-pulse rounded-lg bg-gray-100 dark:bg-gray-800" aria-hidden="true"></div>
        }
      </section>

      <!-- Key numbers -->
      <section class="db-card db-kpis" aria-label="Indicadores del período">
        @if (a) {
          <dl>
            <div>
              <dt>Citas</dt>
              <dd>
                <span class="db-figure">{{ a.kpis.totalAppointments }}</span>
                @if (formatTrend(a.comparison.appointmentsTrend); as t) {
                  <span class="db-trend" [attr.data-tone]="trendTone(a.comparison.appointmentsTrend)">{{ t }}</span>
                }
              </dd>
            </div>
            <div>
              <dt>Ticket promedio</dt>
              <dd>
                <span class="db-figure">{{ formatCompactCurrency(a.kpis.averageTicket) }}</span>
                @if (formatTrend(a.comparison.averageTicketTrend); as t) {
                  <span class="db-trend" [attr.data-tone]="trendTone(a.comparison.averageTicketTrend)">{{ t }}</span>
                }
              </dd>
            </div>
            <div>
              <dt>Clientes nuevos</dt>
              <dd>
                <span class="db-figure">{{ a.kpis.newClients }}</span>
                @if (formatTrend(a.comparison.newClientsTrend); as t) {
                  <span class="db-trend" [attr.data-tone]="trendTone(a.comparison.newClientsTrend)">{{ t }}</span>
                }
              </dd>
            </div>
            <div>
              <dt>Cancelaciones</dt>
              <dd>
                <span class="db-figure">{{ cancellationRate() }} %</span>
                <span class="db-muted">{{ a.kpis.cancelledAppointments }} de {{ a.kpis.totalAppointments }}</span>
              </dd>
            </div>
          </dl>

          @if (clientMix(); as mix) {
            <div class="db-mix">
              <p class="db-label">Clientes atendidos</p>
              <div class="db-mix__bar" aria-hidden="true">
                <span class="db-mix__new" [style.width.%]="mix.newPct"></span>
              </div>
              <p class="db-muted">
                <span class="db-key db-key--new"></span>{{ mix.newCount }} nuevos ({{ mix.newPct }} %)
                <span class="db-key db-key--returning ml-3"></span>{{ mix.returningCount }} que volvieron ({{ mix.returningPct }} %)
              </p>
            </div>
          }
        } @else {
          <div class="grid grid-cols-2 gap-4 animate-pulse" aria-hidden="true">
            @for (i of [1, 2, 3, 4]; track i) {
              <div class="h-12 rounded bg-gray-100 dark:bg-gray-800"></div>
            }
          </div>
        }
      </section>
    </div>

    @if (a) {
      <div class="db-row db-row--half">
        <!-- Most booked services -->
        <section class="db-card" aria-labelledby="db-services-title">
          <div class="db-card__head">
            <h3 id="db-services-title" class="db-card__title">Servicios más pedidos</h3>
            <a routerLink="/reports" class="db-link">Ver informe</a>
          </div>
          @if (topServices().length) {
            <ol class="db-rank">
              @for (s of topServices(); track s.id) {
                <li>
                  <div class="db-rank__row">
                    <span class="truncate">{{ s.name }}</span>
                    <span class="db-rank__value">{{ s.count }} cita{{ s.count !== 1 ? 's' : '' }}</span>
                  </div>
                  <div class="db-rank__track" aria-hidden="true"><span [style.width.%]="s.width"></span></div>
                  <p class="db-muted">{{ formatCurrency(s.revenue) }}</p>
                </li>
              }
            </ol>
          } @else {
            <p class="db-empty">Cuando tengas citas, aquí verás qué servicios piden más.</p>
          }
        </section>

        <!-- Team -->
        <section class="db-card" aria-labelledby="db-team-title">
          <div class="db-card__head">
            <h3 id="db-team-title" class="db-card__title">Tu equipo</h3>
            <a routerLink="/professionals" class="db-link">Ver profesionales</a>
          </div>
          @if (team().length) {
            <ol class="db-rank">
              @for (p of team(); track p.id) {
                <li>
                  <div class="db-rank__row">
                    <span class="truncate">{{ p.name }}</span>
                    <span class="db-rank__value">{{ p.appointmentCount }} cita{{ p.appointmentCount !== 1 ? 's' : '' }}</span>
                  </div>
                  <div class="db-rank__track" aria-hidden="true"><span [style.width.%]="p.width"></span></div>
                  <p class="db-muted">{{ formatCurrency(p.revenue) }}, {{ p.completionRate | number:'1.0-0' }} % completadas</p>
                </li>
              }
            </ol>
          } @else {
            <p class="db-empty">Aquí verás las citas y los ingresos de cada profesional.</p>
          }
        </section>
      </div>
    }
  }
</div>
